import { QuickDistributionFormat } from '@api/ai/enums/AI-chat-completion.enum';
import { CompletionFormatEnum } from '@api/ai/enums/completion-format.enum';
import { DistributionTemplatesEnum } from '@Common/TargetingShared/enum/distribution-templates.enum';
import { QuickDistributionElementEnum } from '@Common/TargetingShared/enum/quick-distribution-element.enum';

export const  quickDistributionCommonElements = [
    QuickDistributionElementEnum.subjectLine,
    QuickDistributionElementEnum.previewText,
    QuickDistributionElementEnum.headline,
];

const blankTemplateElementsMap: Map<CompletionFormatEnum, QuickDistributionElementEnum[]> = new Map([
    [
        CompletionFormatEnum.EMAIL,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.body
        ]
    ],
    [
        CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.aboutUs,
            QuickDistributionElementEnum.contactUs
        ]
    ]
]);

const pressReleaseTemplateElementsMap: Map<CompletionFormatEnum, QuickDistributionElementEnum[]> = new Map([
    [
        CompletionFormatEnum.EMAIL,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.aboutUs,
            QuickDistributionElementEnum.contactUs
        ]
    ],
    [
        CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.aboutUs,
            QuickDistributionElementEnum.contactUs
        ]
    ]
]);

const marketingTemplateElementsMap: Map<CompletionFormatEnum, QuickDistributionElementEnum[]> = new Map([
    [
        CompletionFormatEnum.EMAIL,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.marketingPitch,
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.marketingConclusion,
            QuickDistributionElementEnum.aboutUs
        ]
    ],
    [
        CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION,
        [
            QuickDistributionElementEnum.subHeadline,
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.aboutUs,
            QuickDistributionElementEnum.contactUs
        ]
    ]
]);

const minimalistTemplateElementsMap: Map<CompletionFormatEnum, QuickDistributionElementEnum[]> = new Map([
    [
        CompletionFormatEnum.EMAIL,
        [QuickDistributionElementEnum.body]
    ],
    [
        CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION,
        [
            QuickDistributionElementEnum.body,
            QuickDistributionElementEnum.aboutUs,
            QuickDistributionElementEnum.contactUs
        ]
    ]
]);

export const templateTypesToTemplateElementsMap: Map<DistributionTemplatesEnum, Map<CompletionFormatEnum, QuickDistributionElementEnum[]>> = new Map([
    [DistributionTemplatesEnum.DISTRIBUTION_TEMPLATE_BLANK, blankTemplateElementsMap],
    [DistributionTemplatesEnum.DISTRIBUTION_TEMPLATE_PRESS_RELEASE, pressReleaseTemplateElementsMap],
    [DistributionTemplatesEnum.DISTRIBUTION_TEMPLATE_MARKETING, marketingTemplateElementsMap],
    [DistributionTemplatesEnum.DISTRIBUTION_TEMPLATE_MINIMALIST, minimalistTemplateElementsMap]
]);

const emailElementToAiFormatMap: Map<QuickDistributionElementEnum, QuickDistributionFormat> = new Map([
    [QuickDistributionElementEnum.subjectLine, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_SUBJECTLINE],
    [QuickDistributionElementEnum.previewText, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_PREVIEWTEXT],
    [QuickDistributionElementEnum.headline, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_HEADLINE],
    [QuickDistributionElementEnum.subHeadline, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_SUBHEADLINE],
    [QuickDistributionElementEnum.marketingPitch, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_MARKETINGPITCH],
    [QuickDistributionElementEnum.body, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_BODY],
    [QuickDistributionElementEnum.marketingConclusion, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_MARKETING_CONCLUSION],
    [QuickDistributionElementEnum.aboutUs, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_ABOUTUS],
    [QuickDistributionElementEnum.contactUs, QuickDistributionFormat.QUICK_DISTRIBUTION_EMAIL_CONTACTUS],
]);

const pressReleaseElementToAiFormatMap: Map<QuickDistributionElementEnum, QuickDistributionFormat> = new Map([
    [QuickDistributionElementEnum.subjectLine, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_SUBJECTLINE],
    [QuickDistributionElementEnum.previewText, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_PREVIEWTEXT],
    [QuickDistributionElementEnum.headline, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_HEADLINE],
    [QuickDistributionElementEnum.subHeadline, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_SUBHEADLINE],
    [QuickDistributionElementEnum.marketingPitch, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_MARKETINGPITCH],
    [QuickDistributionElementEnum.body, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_BODY],
    [QuickDistributionElementEnum.marketingConclusion, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_MARKETING_CONCLUSION],
    [QuickDistributionElementEnum.aboutUs, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_ABOUTUS],
    [QuickDistributionElementEnum.contactUs, QuickDistributionFormat.QUICK_DISTRIBUTION_PRESSRELEASE_CONTACTUS],
]);

export const elementToAiFormatMap: Map<CompletionFormatEnum, Map<QuickDistributionElementEnum, QuickDistributionFormat>> = new Map([
    [CompletionFormatEnum.EMAIL, emailElementToAiFormatMap],
    [CompletionFormatEnum.PRESS_RELEASE_DISTRIBUTION, pressReleaseElementToAiFormatMap]
]);
